import { render, staticRenderFns } from "./OpenClaw.vue?vue&type=template&id=152980da&scoped=true"
import script from "./OpenClaw.vue?vue&type=script&lang=js"
export * from "./OpenClaw.vue?vue&type=script&lang=js"
import style0 from "./OpenClaw.vue?vue&type=style&index=0&id=152980da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152980da",
  null
  
)

export default component.exports